import { Breadcrumb } from '@/data/types/Breadcrumb';
import { BreadCrumbTrailEntryView } from '@/data/types/Product';

const CATEGORY_LEVEL_PREFIX: Record<number, string> = {
	1: 'department',
	2: 'category',
	3: 'sub-category',
};

export const buildProductEntityViewName = (
	partNumber: string | undefined,
	entityType = 'product-details'
): string | undefined => (partNumber ? `${entityType}-${partNumber}` : undefined);

export const buildCategoryEntityViewName = (
	breadCrumbTrailEntryView: BreadCrumbTrailEntryView[] | undefined
): string | undefined => {
	if (!breadCrumbTrailEntryView?.length) return undefined;

	const last = breadCrumbTrailEntryView.at(-1);
	if (!last) return undefined;

	const prefix = CATEGORY_LEVEL_PREFIX[breadCrumbTrailEntryView.length] ?? 'category';
	const slug = last.seo?.href?.split('/').filter(Boolean).at(-1);
	const id = last.value;
	if (!slug || !id) return undefined;

	return `${prefix}-${slug}-${id}`;
};

export const buildProductCategoryEntityViewNames = (
	breadcrumb: Breadcrumb[] | undefined,
	entityType = 'product-details'
): string[] => {
	const categoryCrumbs = breadcrumb?.filter((crumb) => crumb.type === undefined) ?? [];

	return categoryCrumbs.slice(0, 3).reduce<string[]>((names, crumb, index) => {
		const level = index + 1;
		const prefix = CATEGORY_LEVEL_PREFIX[level] ?? 'category';
		const slug = crumb.href?.split('/').filter(Boolean).at(-1);
		const id = crumb.value;
		return slug && id ? [...names, `${entityType}-${prefix}-${slug}-${id}`] : names;
	}, []);
};

export const buildCategoryEntityViewNameFromPath = ({
	pathname,
	categoryId,
}: {
	pathname: string | undefined;
	categoryId: string | undefined;
}): string | undefined => {
	if (!categoryId || !pathname) return undefined;

	const segments = pathname
		.replace(/^\/b\//, '')
		.split('/')
		.filter(Boolean);
	const slug = segments.at(-1);
	if (!pathname.startsWith('/b/') || !slug) return undefined;

	const prefix = CATEGORY_LEVEL_PREFIX[segments.length] ?? 'category';
	return `${prefix}-${slug}-${categoryId}`;
};
